import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const getPaginatedEnvironmentTemplates = async (size, firstCursor, lastCursor, prev, getLatest) => {
    const urlParams = Utils.getUrlParams({ size, prev, firstCursor, lastCursor, getLatest });

    const environments = await RequestManager.get({
        url: "/environmentTemplate/v1/" + urlParams
    });
    return environments.data;
};

const getAllEnvironmentTemplates = async () => {
    const response = await RequestManager.get({
        url: "/environmentTemplate/all/v1"
    })
    return response;
};

const getEnvironmentTemplate = async (id) => {
    const response = await RequestManager.get({
        url: "/environmentTemplate/v1/" + id
    })
    return response;
};

const createEnvironmentTemplate = async (body) => {
    const response = await RequestManager.post({
        url: "/environmentTemplate/v1",
        body
    });
    return response;
};

const updateEnvironmentTemplate = async (id, body) => {
    const response = await RequestManager.put({
        url: "/environmentTemplate/v1/" + id,
        body
    });
    return response;
}

const deleteEnvironmentTemplate = async (id) => {
    const response = await RequestManager.del({
        url: "/environmentTemplate/v1/" + id
    });
    return response;
};

const Environment = {
    getAllEnvironmentTemplates,
    getPaginatedEnvironmentTemplates,
    getEnvironmentTemplate,
    createEnvironmentTemplate,
    updateEnvironmentTemplate,
    deleteEnvironmentTemplate,
};

export default Environment;